import { useCallback } from 'react';
import { useFreshdeskContextState } from 'store';

const useIsEntityColumnVisible = () => {
  const { getUiControlsConfigs } = useFreshdeskContextState();

  return useCallback(columnKey => getUiControlsConfigs()?.entityList?.table?.columns?.[columnKey]?.visible !== false, [getUiControlsConfigs]);
};

export default useIsEntityColumnVisible;
